/* External dependencies */
import React from 'react';
import { Provider } from 'react-redux';

/* Local dependencies */
import { createStore } from './store';
import AuthLoader from '../features/auth/AuthLoader';

const store = createStore();

export default ( { element } ) => {
  return (
    <Provider store={store}>
      <AuthLoader />
      {element}
    </Provider>
  );
};
